import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import App from './App'
import { msalInstance, getApiToken } from './auth/authConfig'
import './index.css'

// Attach the Entra ID token to every same-origin /api call. The API validates it
// (signature, issuer, audience, @aviator-energy.com email) and 401s without it -
// this is the only thing gating the company's production and financial data, so
// it must ride on ALL /api requests, not just the ones written to add it.
// Static assets under /data/ (map geojson) don't match and stay untouched.
//
// Custom header, NOT Authorization: Azure Static Web Apps overwrites the
// Authorization header with its own platform token on the managed-functions
// path, so the ID token would never reach the API. X-Aviator-ID-Token passes
// through untouched. (See api/shared/require-aviator.js.)
const rawFetch = window.fetch.bind(window)
window.fetch = async (input, init) => {
    init = init || {}
    const url = typeof input === 'string' ? input : (input && input.url) || ''
    if (url.includes('/api/')) {
        const token = await getApiToken()
        if (token) {
            init.headers = { ...(init.headers || {}), 'X-Aviator-ID-Token': token }
        }
    }
    return rawFetch(input, init)
}

function render() {
    ReactDOM.createRoot(document.getElementById('root')).render(
        <React.StrictMode>
            <MsalProvider instance={msalInstance}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </MsalProvider>
        </React.StrictMode>,
    )
}

// MSAL v3 must be initialized before use. Handle the redirect response first so
// the account is set (and becomes the active account) before anything fetches.
msalInstance.initialize()
    .then(() => msalInstance.handleRedirectPromise())
    .then((result) => {
        if (result && result.account) {
            msalInstance.setActiveAccount(result.account)
        } else if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
            msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
        }
        render()
    })
    .catch((e) => {
        // Never leave a blank page: render anyway; unauthenticated users see the
        // login screen, and /api calls will 401 until they sign in.
        console.error('MSAL init failed', e)
        render()
    })
